import React, { CSSProperties } from "react";

import {
	Bar,
	BarChart,
	CartesianGrid,
	Legend,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";

export interface VolumeServiceData {
	name: string;
	ks: number;
	al: number;
	mk: number;
}

interface ProgressListTableProps {
	style?: CSSProperties | undefined;
	data?: VolumeServiceData[];
	title?: string;
}

const VolumeServiceLevelChart = ({
	style,
	data,
	title,
}: ProgressListTableProps) => {
	return (
		<div className="volumeServiceLevelChart" style={style}>
			<div
				className="flex flex-col gap-2 pb-2 "
				style={{ paddingLeft: "14px", paddingTop: "12px" }}
			>
				<h1 className="StatisticTitle">{title}</h1>
				<div
					style={{
						display: "flex",
						gap: "1rem",
						marginBottom: "1rem",
					}}
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "0.5rem",
						}}
					>
						<span
							style={{
								width: 10,
								height: 10,
								backgroundColor: "#4F16C2",
								borderRadius: "50%",
							}}
						/>
						<span>Kosovë</span>
					</div>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "0.5rem",
						}}
					>
						<span
							style={{
								width: 10,
								height: 10,
								backgroundColor: "#FFB5B5 ",
								borderRadius: "50%",
							}}
						/>
						<span>Shqipëri</span>
					</div>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "0.5rem",
						}}
					>
						<span
							style={{
								width: 10,
								height: 10,
								backgroundColor: "#28BFFF",
								borderRadius: "50%",
							}}
						/>
						<span>Maqedoni</span>
					</div>
				</div>
			</div>
			<ResponsiveContainer width="100%" height="80%">
				<BarChart
					width={500}
					height={300}
					data={data}
					barCategoryGap="20%"
					barGap="5%"
				>
					<CartesianGrid strokeDasharray="5 12" />
					<XAxis dataKey="name" />
					<YAxis />
					<Tooltip />
					<Bar
						dataKey="ks"
						stackId="a"
						fill="#4F16C2"
						// radius={[10, 10, 0, 0]}
						// stroke="#fff"
						// strokeWidth={2}
					/>
					<Bar
						dataKey="mk"
						stackId="a"
						fill="#28BFFF"
						// radius={[0, 0, -10, 0]}
						// stroke="#fff"
						// strokeWidth={2}
					/>
					<Bar
						dataKey="al"
						stackId="a"
						fill="#FFB5B5"
						radius={[4, 4, 0, 0]}
						stroke="#FFB5B5"
						// strokeWidth={2}
					/>
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};

export default VolumeServiceLevelChart;
